// FILE: src/blueprint/state/initialState.js

import { ROUTES } from '../app/routes.js';

export const initialState = Object.freeze({
  route: ROUTES.ENTRY,

  // Config (client -> server)
  config: null,
  packId: '',

  // Blueprint-level coach preferences
  selectedCoachId: 'system',
  selectedTypingMode: 'fast',

  // Current resolved coach context
  coachContext: {
    requested: null,
    active: {
      id: null,
      label: '',
      source: 'none',
    },
    available: [],
    fallbackUsed: false,
  },

  // Overview help state
  overviewHelp: {
    isLoading: false,
    error: '',
    rail: [],
    assistant: {
      requested: null,
      active: {
        id: null,
        label: '',
        source: 'none',
      },
      available: [],
      fallbackUsed: false,
    },
    updatedAt: null,
  },

  // Data
  blueprint: null,

  // UI flags
  isLoading: false,
  error: '',
  showDescription: true,
  showTime: true,

  // Module navigation
  activeModuleId: null,
  activeTrackId: null,

  // Active module content
  activeModuleDoc: null,
  activeContentIndex: 0,
  explanationMode: false,
  answers: {},

  // Progressive insights
  insights: {
    isLoading: false,
    error: '',
    cards: [],
    meta: null,
    lastUpdatedAt: null,
  },
});
